export interface HelpMedia {
  video: string;
  captions: string;
  poster: string;
}

/**
 * Where an announcement's video, captions and poster live. The only place
 * that knows: help content names an id, never a URL.
 *
 * For now by convention, under the app's own origin: `make help-media`
 * uploads to `/help-media/<id>/` in the UI bucket. Same origin, so the
 * captions track needs no CORS. Later this asks the API instead
 * (base-telemetry-web-api#219 §5) and returns null for an id with no media.
 */
export const helpMedia = (id: string): HelpMedia | null => {
  const base = `${process.env.PUBLIC_URL ?? ""}/help-media/${id}`;
  return {
    video: `${base}/video.mp4`,
    captions: `${base}/captions.vtt`,
    poster: `${base}/poster.png`,
  };
};
